module.exports = __webpack_public_path__ + "static/img/kefu@3x69563ca.png";